module.exports = __webpack_public_path__ + "img/074.604cae6a.jpeg";